"use client";

import Link from "next/link";
import { LoaderCircle } from "lucide-react";
import { useFormStatus } from "react-dom";
import { login } from "@/app/actions";
import { useAccountSession } from "@/providers/account-session";
import { SaveButtonSpinner } from "@/components/save-button-spinner";

function Arrow() {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      aria-hidden="true"
    >
      <path className="portal-home-sign-in-line" d="M0 5h7" />
      <path className="portal-home-sign-in-tip" d="m1 1 4 4-4 4" />
    </svg>
  );
}

function SignIn() {
  const { pending } = useFormStatus();
  return (
    <div className="flex items-center">
      <button
        type="submit"
        className="portal-home-sign-in"
        disabled={pending}
        aria-busy={pending}
      >
        Sign in <Arrow />
      </button>
      <SaveButtonSpinner show={pending} />
    </div>
  );
}

export function HomeAccountAction() {
  const { session, resolving } = useAccountSession();
  const loading = !session?.token && resolving;
  return (
    <div className="portal-home-sign-in-form mt-6 min-h-10">
      <div className="portal-home-account-transition" data-loading={loading}>
        <div
          className="portal-home-account-spinner flex h-[33px] w-fit items-center"
          role={loading ? "status" : undefined}
          aria-label={loading ? "Checking your session" : undefined}
          aria-hidden={!loading}
        >
          <LoaderCircle
            aria-hidden="true"
            className="size-5 animate-spin text-brand-primary motion-reduce:animate-none"
          />
        </div>
        <div
          className="portal-home-account-button"
          inert={loading}
          aria-hidden={loading}
        >
          {session?.token ? (
            <Link
              href="/settings/subscriptions"
              className="portal-home-sign-in"
            >
              Go to Subscriptions <Arrow />
            </Link>
          ) : (
            <form action={login}>
              <SignIn />
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
